// services/atualizarApartamento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const cadastrarLead = async (valuesLead: any) => {
  const URL = `${Globais.DOMINIOBACK}/lead`;

  try {
    const response = await axios.post(URL, valuesLead);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
